import { Container } from "@mui/material";
import { createListCollection } from "@ark-ui/react";
import { Form } from "react-final-form";
import { useParams } from "react-router-dom";
import { useCallback } from "react";

import { useTranslation } from "@/lib/i18n";
import Breadcrumbs from "@/features/admin/features/organisations/components/breadcrumbs";
import Select from "@/components/select/select";
import RichTextEditor from "@/features/shared/components/rte/rte";
import Stack from "@/components/stack/stack";
import Button from "@/components/button/button";
import { useExtranetDetailQuery } from "@/features/admin/hooks/queries";
import { useExtranetMutation } from "@/features/admin/hooks/mutations";
import { UpdateExtranetBodyLocaleEnum } from "@/lib/api";

type FormValues = {
  locale: UpdateExtranetBodyLocaleEnum;
  general_info_content: string;
};

const localeCollection = createListCollection({
  items: [
    {
      label: "Dutch",
      value: "nl",
    },
    {
      label: "English",
      value: "en",
    },
  ],
});

const ExtranetDetailPage = () => {
  const { t } = useTranslation();
  const { extranetId } = useParams();
  const { data: extranet } = useExtranetDetailQuery(extranetId ?? "");
  const { mutate: updateExtranet } = useExtranetMutation(extranetId ?? "");
  console.log(extranet);

  const onSubmit = useCallback(
    (values: FormValues) => {
      updateExtranet(values);
    },
    [updateExtranet],
  );

  if (!extranet) return null;

  const initialValues = {
    locale: (localeCollection.find(extranet?.locale)?.value ??
      localeCollection.firstValue ??
      "") as UpdateExtranetBodyLocaleEnum,
    general_info_content: extranet?.general_info_content ?? "",
  };

  return (
    <Container sx={{ mt: { xs: 2, md: 6 } }}>
      <Breadcrumbs
        paths={[
          { label: t("admin.extranets.plural"), value: "extranets" },
          { label: extranet.name, value: extranet.name },
        ]}
      />
      <h1>{extranet.name}</h1>

      <Form<FormValues>
        initialValues={initialValues}
        onSubmit={onSubmit}
        render={({ handleSubmit, values, form }) => (
          <form onSubmit={handleSubmit}>
            <Stack flexDirection="column" gap={16}>
              <Select
                name="locale"
                collection={localeCollection}
                label="Language"
                value={values.locale}
                onValueChange={(value) =>
                  form.change("locale", value as UpdateExtranetBodyLocaleEnum)
                }
              />

              <RichTextEditor
                name="general_info_content"
                label="Login page content"
                initialValue={initialValues.general_info_content}
              />

              <Button variant="primary" type="submit">
                Submit
              </Button>
            </Stack>
          </form>
        )}
      />
    </Container>
  );
};

export default ExtranetDetailPage;
